//Internship.js
import React, { useState } from "react";
import "./App.css";
import "./Internship.css";

//function Internship() {         
 // return  <div>
    const Internship = () => {
      
      const [formData, setFormData] = useState({
        
        name: "",
        email: "",
        message: "",
        subject: "", // Add subject state
        resume: null, // Add resume state
      });

        // Subject options for dropdown
  const subjects = [
    "Civil Law",
    "Criminal Law",
    "Corporate Law",
    "Family Law",
    "Real Estate Law",
    "Constitutional Law",
    "Intellectual Property Law",
    "Tax Law",
    "Other"
  ];
    
      const handleChange = (e) => {
        if (e.target.name === "resume") {
      setFormData({ ...formData, resume: e.target.files[0] }); // Handle file input
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };
    
      const handleSubmit = async (e) => {
        e.preventDefault();

         e.target.reset(); // clears file input
  setFormData({
    name: "",
    email: "",
    message: "",
    subject: "",
    resume: null
  });

          const formToSend = new FormData();
    formToSend.append("name", formData.name);
    formToSend.append("email", formData.email);
    formToSend.append("subject", formData.subject);
    formToSend.append("message", formData.message);
    if (formData.resume) {
      formToSend.append("resume", formData.resume); // Append resume file
    }
    
        try {
          const response = await fetch("https://www.legalexpertsindia.in/api/send-email", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
             body: formToSend, 
            body: JSON.stringify(formData),
        
          });
    
          const data = await response.json();
          if (data.success) {
            alert("✅ Email sent successfully!");
            setFormData({ name: "", email: "", subject: "", message: "", resume: null});
          } else {
            alert("❌ Failed to send email.");
          }
        } catch (error) {
          console.error(error);
          alert("Error sending email.");
        }
      };
    
      return ( 
  <><img src="/internships.jpg" alt="Header" />

   <div  className="internship-headings">
      <center><h5>Legal Experts india offers a highly competitive Internship programme</h5>
      <h5>Fields marked with * are mandatory.</h5> </center>
      </div>
      <form onSubmit={handleSubmit} className="internship-form">
        <input
          type="text"
          name="name"
          placeholder="Your Name *"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email "
          name="email"
          placeholder="Your Email *"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <select
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          required
        >
          <option value="">Select Subject *</option>
          {subjects.map((subject) => (
            <option key={subject} value={subject}>
              {subject}
            </option>
          ))}
        </select>
        <textarea
          name="message"
          placeholder="Your Message *"
          value={formData.message}
          onChange={handleChange}
          required
        />
        <div className="file-upload">
  <label className="file-label">
    Upload Resume
    <input
      type="file"
      name="resume"
      onChange={handleChange}
      accept=".pdf,.doc,.docx"
      required
    />
  </label>

  <span className="file-name">
    {formData.resume ? formData.resume.name : "No resume selected"}
  </span>
</div>
        <button type="submit">Submit</button>

</form>
<div className="links-container">
          <div className="links-box">
            <h3>Important Websites Related To Government of India</h3>
            <ul>
              <li>
                <a
                  href="http://supremecourtofindia.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  The Supreme Court, India
                </a>
              </li>
              <li>
                <a
                  href="http://india.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  National Portal of India
                </a>
              </li>
              <li>
                <a
                  href="http://eci.nic.in/eci/eci.html/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Election Commission of India
                </a>
              </li>
              <li>
                <a
                  href="http://mha.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ministry of Home Affairs
                </a>
              </li>
              <li>
                <a
                  href="http://www.mea.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ministry of External Affairs
                </a>
              </li>
              <li>
                <a
                  href="http://boi.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Bureau Of Immigration
                </a>
              </li>
              <li>
                <a
                  href="http://nhrc.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  National Human Rights Commission
                </a>
              </li>
              <li>
                <a
                  href="http://passportindia.gov.in//"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Passport Services, India
                </a>
              </li>
              <li>
                <a
                  href="http://www.crpf.gov.in/default.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Central Reserve Police Force{" "}
                </a>
              </li>
              <li>
                <a
                  href="http://bsf.gov.in/SitePages/Home.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Border Security Force
                </a>
              </li>
              <li>
                <a
                  href="http://www.ssb.nic.in/index.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sashastra Seema Bal
                </a>
              </li>
              <li>
                <a
                  href="http://itbpolice.nic.in/itbpwebsite/index.html/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Indo-Tibetan Border Police Force
                </a>
              </li>
            </ul>
          </div>

          <div className="links-box">
            <h3>Important Websites Related To Uttar Pradesh Govt.</h3>
            <ul>
              <li>
                <a
                  href="http://uplabour.gov.in/index.aspx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Labour Departmentt, Government of Uttar Pradesh
                </a>
              </li>
              <li>
                <a
                  href="http://allahabadhighcourt.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Allahabad High Court
                </a>
              </li>
              <li>
                <a
                  href="http://ceouttarpradesh.nic.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chief Electoral Officer, U.P.
                </a>
              </li>
              <li>
                <a
                  href="http://www.up.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Government Portal
                </a>
              </li>
              <li>
                <a
                  href="http://uppolice.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Police
                </a>
              </li>
              <li>
                <a
                  href="http://jansunwai.up.nic.in//"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Integrated Grievance Redressal System (IGRS), Government of
                  Uttar Pradesh{" "}
                </a>
              </li>
              <li>
                <a
                  href="http://www.uppbpb.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Police Recruitment Board
                </a>
              </li>
              <li>
                <a
                  href="http://uptourism.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Tourism
                </a>
              </li>
              <li>
                <a
                  href="http://uplegisassembly.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UP Legislative Assembly
                </a>
              </li>
            </ul>
          </div>
        </div>
    </>

    
  );
    };

export default Internship;
